<div class="grid grid-gutter-16">
  <div *ngFor="let ts of items" class="grid-item">
    <div class="grid grid-gutter-16 grid-column">
      <div class="grid-item">
        <div class="typography typography-headline typography-medium grey-800">
          Тест-система:&nbsp;
          <span class="typography typography-headline green-basic"
            >{{ ts.name }}&nbsp;({{ ts.country }})</span
          >
        </div>
      </div>
      <div class="grid-item">
        <div class="row-nowrap grid grid-gutter-28">
          <div *ngIf="ts.specificity?.value" class="grid-item">
            <div
              class="row-nowrap grid grid-gutter-8 grid-nowrap align-items-center"
            >
              <div class="grid-item typography">Специфичность</div>
              <div class="grid-item">
                <span
                  class="tag tag-m tag-white tag-bordered tag-rounded typography typography-bold grey-800"
                >
                  {{ ts.specificity?.value }}&nbsp;%
                </span>
              </div>
            </div>
          </div>

          <div *ngIf="ts.sensitivity?.value" class="grid-item">
            <div
              class="row-nowrap grid grid-gutter-8 grid-nowrap align-items-center"
            >
              <div class="grid-item typography">Чувствительность</div>
              <div class="grid-item">
                <span
                  class="tag tag-m tag-white tag-bordered tag-rounded typography typography-bold grey-800"
                >
                  {{ ts.sensitivity?.value }}&nbsp;%
                </span>
              </div>
            </div>
          </div>

          <div *ngIf="ts.result" class="grid-item">
            <div
              class="row-nowrap grid grid-gutter-8 grid-nowrap align-items-center"
            >
              <div class="grid-item typography">Результат</div>
              <div class="grid-item">
                <span
                  class="tag tag-m tag-white tag-bordered tag-rounded typography typography-bold grey-800"
                  style="text-align: left; white-space: normal"
                >
                  {{ ts.result }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
